import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const pettyCashRoutes = [
	{
		key: "petty-cash-spend-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/petty-cash-spends/create`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/SpendCreate")),
	},
	{
		key: "petty-cash-spends",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/petty-cash-spends`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/Spends")),
	},
	{
		key: "petty-cash-user-spends-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/user-spends/create`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/UserSpendCreate")),
	},
	{
		key: "petty-cash-user-spends",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/user-spends`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/UserSpends")),
	},
	{
		key: "petty-cash-cheques",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/petty-cash-cheques`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/Cheques")),
	},
	{
		key: "petty-cash-requests",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/petty-cash-requests`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/Requests")),
	},
	{
		key: "petty-cash-user-requests",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/petty-cash-user-requests`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/UserRequests")),
	},
	{
		key: "petty-cash-common-request-approvals",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/petty-cash-common-request-approvals`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/CommonRequestApprovals")),
	},
	{
		key: "petty-cash-floats",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/floats`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/Floats")),
	},
	{
		key: "petty-cash-floats-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/petty-cash/floats/create`,
		component: React.lazy(() => import("views/app-views/petty-cash/pages/FloatCreate")),
	},
];
